import { api } from "../lib/axios";

import type {
    VectorEmbeddingModel,
    VectorChunkingMethod,
    VectorMetadata
} from "../types/vector";
import type { ApiData } from "./apiData";

interface VectorApiParams {
    id?: string
    nameSpace: string
    spaceId?: string
}

interface CreateNamespaceBody {
    embeddingModelName: VectorEmbeddingModel
    files: Array<{
        customFileName?: string
        fileUrl: string
        chunkingMethod: VectorChunkingMethod
        metadatas: Array<VectorMetadata>
    }>
}

interface CreateNamespaceResponseData {}

type CreateNamespaceResponse = ApiData<CreateNamespaceResponseData>

async function createNamespace({ 
    body,
    params
}: {
    body: CreateNamespaceBody,
    params: VectorApiParams
}) {
    const response = await api.post<CreateNamespaceResponse>(
        '/vector/add', body, { params }
    )

    return response.data.data
}

export {
    createNamespace,
    type VectorApiParams,
    type CreateNamespaceBody,
    type CreateNamespaceResponseData,
    type CreateNamespaceResponse
}